import * as React from 'react';

import { DropdownMenu } from '../../components/DropdownMenu';
import { TDropdownType } from '../../components/DropdownMenu/interfaces';
import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';
import { IDropdownMenuLink } from '../../types/dropdownMenuLink';
import { trackingClickFSKLink, trackingShowFSKLink } from '../../utils/analytics/trackFSKLink';
import { isFskByIconName } from '../../utils/isFskByIconName';
import { sendFSKTeaserEvent } from '../../utils/analytics/sendFSKTeaserEvent';
import { sectionToCategoryMap } from '../../constants/sectionsAndCategories';
import { getBanner } from './helpers/getBanner';

export interface IDropdownMenuContainerState {
  hasShadow?: boolean;
  links: IDropdownMenuLink[];
  show: boolean;
}

export interface IDropdownMenuContainerProps {
  catalogDevelopersUrl?: string;
  catalogRealtorsUrl?: string;
  isOpen?: boolean;
  links: IDropdownMenuLink[];
  name: TDropdownType;
  onClose?(): void;
  onMouseLeave?(key: string): void;
  otherLinks?: IOtherLinksSchema | null;
  dealRentHeaderBannerEnabled: boolean;
  regionId: number;
  pikRegions: number[];
  section?: string;
}

export class DropdownMenuContainer extends React.Component<IDropdownMenuContainerProps, IDropdownMenuContainerState> {
  public constructor(props: IDropdownMenuContainerProps) {
    super(props);

    const { links } = props;

    this.state = {
      hasShadow: false,
      links,
      show: true,
    };
  }

  public componentDidMount() {
    const { name } = this.props;

    this.setState({
      hasShadow: window.___header_serpPageType !== name,
    });
  }

  public componentDidUpdate({ isOpen: prevIsOpen }: Readonly<IDropdownMenuContainerProps>) {
    const { isOpen, section } = this.props;
    // Не знаю как лучше отправлять аналитику на показ блока по условию для ФСК
    if (!prevIsOpen && isOpen) {
      const { links } = this.props;

      links.forEach((group: IDropdownMenuLink) => {
        if (group.children) {
          group.children.forEach(({ icon, url }: IDropdownMenuLink) => {
            if (isFskByIconName(icon)) {
              trackingShowFSKLink(section);
              sendFSKTeaserEvent({
                action: 'show',
                bannerPlace: sectionToCategoryMap[section || ''],
                hitUrl: url || '',
              });
            }
          });
        }
      });
    }
  }

  public onLinkClick = (section?: string) => ({ icon, url }: IDropdownMenuLink) => {
    if (isFskByIconName(icon)) {
      trackingClickFSKLink(section);
      sendFSKTeaserEvent({
        action: 'click',
        bannerPlace: sectionToCategoryMap[section || ''],
        hitUrl: url || '',
      });
    }
  };

  public render() {
    const {
      catalogDevelopersUrl,
      catalogRealtorsUrl,
      isOpen,
      name,
      onClose,
      onMouseLeave,
      otherLinks,
      dealRentHeaderBannerEnabled,
      regionId,
      pikRegions,
      section,
    } = this.props;
    const { hasShadow, links } = this.state;
    const linksOther = otherLinks || ({} as IOtherLinksSchema);
    const banner = getBanner({ name, links, linksOther, isOpen, regionId });

    return (
      <DropdownMenu
        catalogDevelopersUrl={catalogDevelopersUrl}
        catalogRealtorsUrl={catalogRealtorsUrl}
        hasShadow={hasShadow}
        isOpen={isOpen}
        links={links}
        name={name}
        onClose={onClose}
        onMouseLeave={onMouseLeave}
        otherLinks={linksOther}
        dealRentHeaderBannerEnabled={dealRentHeaderBannerEnabled}
        banner={banner}
        onLinkClick={this.onLinkClick(section)}
        regionId={regionId}
        pikRegions={pikRegions}
      />
    );
  }
}
